import { Location } from '../../location';

export class ScheduleServiceLocation extends Location {
	constructor() {
		super('page-schedule-service-button');
	}
}
